import * as deloitteCookies from 'js-cookie/src/js.cookie.js';
import * as gfunctions from '../../../js/generalFunctions';

CCL.bookingBuddyObj = {
  autoload: [
    ['initialLoad', $('.openBookingBuddyModal').length > 0],
    ['checkoutBBLoad', $('#chekoutBbDiv').length > 0],
    ['navCruiseClose', $('#navCruiseClose').length > 0]
  ],
  selectedMonth: '',
  activeSailingId: null,
  bookingAdded: false,
  currentProductCode: false,
  giftGiver: null,
  checkout: false,
  allData: {},
  firstTime: false,
  loggedInUser: false,
  hasSailings: false,
  isCruiseManager: false,
  isPDP: false,
  includeAUSailings: false,
  data: {
    months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  },
  selectInitialShop: 'browseAllCheckBox',
  ajaxData: {
    firstName: '',
    lastName: '',
    bookingNumber: '',
    sailingStartDate: '',
    sailingEndDate: '',
    shipCode: '',
    email: '',
    phoneNumber: '',
    ageRangeBegin: '',
    ageRangeEnd: '',
    dateOfBirth: '',
    embarkationPortCode: '',
    travellingCompanionFirstName: '',
    travellingCompanionLastName: '',
    productCode: '',
    ageCode: ''
  },

  emptyObj: {
    firstName: '',
    lastName: '',
    bookingNumber: '',
    sailingStartDate: '',
    sailingEndDate: '',
    shipCode: '',
    email: '',
    phoneNumber: '',
    ageRangeBegin: '',
    ageRangeEnd: '',
    dateOfBirth: '',
    embarkationPortCode: '',
    travellingCompanionFirstName: '',
    travellingCompanionLastName: '',
    productCode: '',
    ageCode: ''
  },

  getMonthList() {
    const d = new Date();
    const currentMonth = d.toLocaleString('en-us', { month: 'short' });
    const currentYear = d.getFullYear();
    const currentMonthIndex = d.getMonth(); // this.data.months.indexOf(String(currentMonth));
    const arrFromCurrentMonth = this.data.months.slice(currentMonthIndex, 12);
    const temp1 = [];
    const temp2 = [];
    $(arrFromCurrentMonth).each((i, v) => {
      const index = this.data.months.indexOf(
        this.data.months.filter(x => x === v)[0]
      );
      const selectedMonth = index + 1;
      temp1.push({
        label: `${v} ${currentYear}`,
        key: selectedMonth < 10 ? `0${selectedMonth}-01-${currentYear}` : `${selectedMonth}-01-${currentYear}`
      });
    });
    $(this.data.months).each((i, v) => {
      const index = this.data.months.indexOf(
        this.data.months.filter(x => x === v)[0]
      );
      const selectedMonth = index + 1;
      temp2.push({
        label: `${v} ${currentYear + 1}`,
        key: selectedMonth < 10 ? `0${selectedMonth}-01-${currentYear + 1}` : `${selectedMonth}-01-${currentYear + 1}`
      });
    });
    return [...temp1, ...temp2];
  },

  navCruiseClose() {
    $('#navCruiseClose').click((e) => {
      e.preventDefault();
      e.stopPropagation();
      this.cruiseCloseAjax();
    });
  },

  checkoutBBLoad() {
    this.checkout = true;
    this.includeAUSailings = false;
    this.loadInitialModal();
  },


  loadBookinBuddyModal(e) {
    e.preventDefault();
    this.selectInitialShop = $(e.currentTarget).data('selectshopvalue');
    if (e.currentTarget.dataset.iscruisemanager && e.currentTarget.dataset.iscruisemanager === 'true') {
      this.isCruiseManager = true;
    }
    this.loadInitialModal();
  },

  initialLoad() {
    this.bbCarnivalGiftingBookingCookieCall();
    $(document.body).on('click keypress', '.openBookingBuddyModal', (customEvent) => {
      if (customEvent.type === 'click' || customEvent.keyCode === 13) {
        this.includeAUSailings = true;
        this.loadBookinBuddyModal(customEvent);
      }
    });
  },

  bbCarnivalGiftingBookingCookieCall() {
    // check if we are on shop page
    if (/shop/i.test(window.location.pathname)) {
      let ajaxUrl = '';
      if (window.location.hostname === 'localhost' && window.location.port === '6565') {
        ajaxUrl = 'json-data/booking-buddy.json';
      } else {
        ajaxUrl = '/shop/gifting/getInfo';
      }
      $.ajax({
        type: 'GET',
        url: ajaxUrl
      }).done((response) => {
        if (response.sailings && response.sailings.length) {
          if (!response.sailings.some(x => x.giftGiver) && deloitteCookies.get(`carnivalGiftingBookingCookie-${response.vifp}`)) {
            if (response.userMode === 'LOGGED_IN_NON_BOOKED_GUEST' || response.userMode === 'LOGGED_IN_BOOKED_GUEST') {
              const requestParams = deloitteCookies.getJSON(`carnivalGiftingBookingCookie-${response.vifp}`);
              Object.assign(this.ajaxData, requestParams);
              this.save(true);
            }
          }
        }
      }).fail(() => {
        gfunctions.hideLoader();
      });
    }
  },

  loadInitialModal(isLbMode = false, productCode = false, isPDP = false) {
    this.isLbMode = isLbMode;
    this.isPDP = isPDP;
    this.currentProductCode = productCode;
    //  empty data every time first modal opens
    Object.assign(this.ajaxData, this.emptyObj); // assign empty obj
    // $.each(this.ajaxData, (k, v) => {
    //   this.ajaxData[k] = '';
    // });
    let ajaxUrl = '';
    if (window.location.hostname === 'localhost' && window.location.port === '6565') {
      ajaxUrl = 'json-data/booking-buddy.json';
    } else {
      ajaxUrl = this.includeAUSailings ? '/shop/gifting/getInfo?includeAUSailings=true' : '/shop/gifting/getInfo';
    }
    gfunctions.showLoader();
    $.ajax({
      type: 'GET',
      url: ajaxUrl
    }).done((response) => {
      gfunctions.getBookingBuddyModalHtml(null, (res) => {
        response.months = this.getMonthList();
        response.checkout = this.checkout;
        // if any of the booking have giftGiver hide firstName/lastname form
        if (response.sailings) {
          this.bookingAdded = !response.sailings.some(x => x.giftGiver);
        } else {
          this.bookingAdded = true;
        }
        response.bookingAdded = this.bookingAdded;
        const compiledHtml = gfunctions.createDynamicHTML(res, response);
        this.allData = response;
        if (this.checkout) {
          $('#chekoutBbDiv').html(compiledHtml);
        } else {
          $('#bbModalDynamicHtmlDiv').html(compiledHtml);
          gfunctions.showModal('bookingBuddyModal');
          this.modalEvents();
        }
        if (response.activeSailingId && $(`#${response.activeSailingId}`).length) {
          $(`#${response.activeSailingId}`)[0].checked = true;
          this.activeSailingId = response.activeSailingId;
        }
        // attach click events only one time or else it will trigger multiple call
        // if (!this.firstTime) {

        //   this.firstTime = true;
        // }
        this.allClickEvents();
        this.radioSelect();

        this.loggedInUser = response.loggedInUser;
        this.hasSailings = response.hasSailings;

        // if user is in browseMode then browse option should be selected
        if (!response.loggedInUser || (response.loggedInUser && !response.hasSailings)) {
          $('#label-browseAllCheckBox').trigger('click');
        }

        // on checkout page open the form by default
        if (this.checkout) {
          $('#giftLinkFormCheckBoxLabel').trigger('click');
        }

        // if user is in cruise manager page hide right side section
        if (this.isCruiseManager) {
          $('.rightSidebar').hide();
          $('#BookingBuddyModalTitle').html(response.headerTextCMP);
        }
        $('.link-a-booking').hide();
        this.selectRadioBrowseOrGift(response);
        this.showComponentIfBrowseOrLoggedin(response);
        this.showComponentIfBookedGuestOrNotBookedG(response);
        this.showComponentsIfOrganizer(response);
      });


      gfunctions.hideLoader();
    }).fail(() => {
      gfunctions.hideLoader();
    });
  },

  selectRadioBrowseOrGift(response) {
    // select the proper radio button if click in modal or gift-link in browse mode
    if (response.userMode === 'GUEST' || response.userMode === 'ANONYMOUS' || response.userMode === 'LOGGED_IN_NON_BOOKED_GUEST') {
      let radio = document.getElementById(this.selectInitialShop);
      if (!radio) {
        radio = document.getElementById('giftLinkFormCheckBox');
      }
      if (radio) {
        radio.checked = true;
        $(radio).trigger('click');
        $(radio).focus();
      }
    }
  },

  showComponentsIfOrganizer(response) {
  // show or hide components if the userMode is organizer
    $('.link-a-booking').removeAttr('data-isorganizer');
    if (response.userMode === 'ORGANIZER') {
      $('#linkBookinFormCheckboxContainer').hide();
      $('.link-a-booking').show();
      $('.link-a-booking').attr('data-isorganizer', 'true');
    }
  },

  showComponentIfBookedGuestOrNotBookedG(response) {
  // show link-a-booking component if the usermode is LOGGED_IN_BOOKED_GUEST or LOGGED_IN_NON_BOOKED_GUEST
    if (response.userMode === 'LOGGED_IN_BOOKED_GUEST' || response.userMode === 'LOGGED_IN_NON_BOOKED_GUEST') {
      $('.link-a-booking').show();
    }
  },

  showComponentIfBrowseOrLoggedin(response) {
  // if user is in browseMode then browse option should be selected
    if (response.userMode === 'GUEST' || response.userMode === 'ANONYMOUS' || response.userMode === 'LOGGED_IN_BOOKED_GUEST') {
      $('#linkBookinFormCheckboxContainer').hide();
    }
  },


  fetchBooking() {
    if (this.activeSailingId === 1) {
      this.save();
    } else if (this.activeSailingId === 0) {
      gfunctions.setSailingContextCookie('browse');
      this.browseAjaxCall();
    } else if (this.activeSailingId === 2) {
      this.linkBookingSubmit();
    } else {
      gfunctions.setSailingContextCookie(this.activeSailingId);
      if (this.checkout) {
        this.bbSailingCheckoutAjax();
      } else if (this.isLbMode) {
        this.bbLbAddToCartAjax(this.activeSailingId);
      } else if (!this.checkout) {
        if (this.giftGiver === 'true') {
          deloitteCookies.set('giftGiver', 'true');
          window.location.href = '/shop';
        } else {
          window.location.href = '/booked/home';
        }
      }
    }
  },

  setBBActiveSailing(id) {
    gfunctions.showLoader();
    $.ajax({
      type: 'GET',
      url: `/shop/gifting/refresh-sailings/${id}`
    }).done((response) => {
      gfunctions.setSailingContextCookie(response.activeSailingId);
      setTimeout(() => {
        window.location.href = '/booked/home';
      }, 3000);
      gfunctions.hideLoader();
    }).fail(() => {
      gfunctions.hideLoader();
    });
  },

  linkBookingSubmit() {
    gfunctions.showLoader();
    const token = $('#csrfSessionToken').data('csrf');
    const bookingNumber = $('.link-booking-number').val();
    const lastName = $('.link-last-name').val();
    const saveToProfile = $('#bb_save-to-profile-input')[0].checked;
    const bookings = [{
      bookingNumber: bookingNumber.toUpperCase(),
      lastName: lastName.toUpperCase(),
      saveToProfile
    }];
    gfunctions.showLoader();
    $.ajax({
      type: 'POST',
      url: '/booked/api/v1.0/bookings',
      xhrFields: { withCredentials: true },
      crossDomain: true,
      data: JSON.stringify({ bookings }),
      contentType: 'application/json',
      headers: {
        CSRFToken: token
      }
    }).done((response) => {
      gfunctions.hideLoader();
      if (response.responses.filter(x => x.success).length) {
        this.setBBActiveSailing(response.responses[0].bookingNumber);
      } else {
        $('.link-error-text').show();
      }
      gfunctions.hideLoader();
    }).fail(() => {
      gfunctions.hideLoader();
    });
  },

  save(giftingSailingLookup = false) {
    gfunctions.showLoader();
    let token = $('#csrfSessionToken').data('csrf');
    if ($('#checkoutCsrfToken').length) {
      token = $('#checkoutCsrfToken').data('csrf');
    }

    if (this.isLbMode) {
      this.ajaxData.productCode = this.currentProductCode;
    }

    this.ajaxData.giftingSailingLookup = giftingSailingLookup;

    // first modal data
    this.ajaxData.checkout = this.checkout;

    this.ajaxData.firstName = $('#giftLinkForm .recipient-f-name').val() ? $('#giftLinkForm .recipient-f-name').val() : this.ajaxData.firstName;
    this.ajaxData.lastName = $('#giftLinkForm .recipient-l-name').val() ? $('#giftLinkForm .recipient-l-name').val() : this.ajaxData.lastName;
    this.ajaxData.bookingNumber = $('#giftLinkForm .booking-number').val() ? $('#giftLinkForm .booking-number').val() : this.ajaxData.bookingNumber;

    this.ajaxData.bookingNumber = this.ajaxData.bookingNumber && this.ajaxData.bookingNumber !== '' ? this.ajaxData.bookingNumber.toUpperCase() : this.ajaxData.bookingNumber;
    this.ajaxData.sailingStartDate = this.selectedMonth;

    // second modal data
    this.ajaxData.shipCode = this.ajaxData.shipCode ? this.ajaxData.shipCode : '';
    this.ajaxData.email = $('.multiple-sailing-modal-dialog #emailAddress').val() ? $('.multiple-sailing-modal-dialog #emailAddress').val() : this.ajaxData.email;
    this.ajaxData.phoneNumber = $('.multiple-sailing-modal-dialog #phoneNumber').val() ? $('.multiple-sailing-modal-dialog #phoneNumber').val() : this.ajaxData.phoneNumber;


    // third modal data
    this.ajaxData.ageCode = this.ajaxData.ageCode ? this.ajaxData.ageCode : '';
    this.ajaxData.dateOfBirth = $('#sailingInfoForm #dob').val() ? $('#sailingInfoForm #dob').val() : this.ajaxData.dateOfBirth;
    this.ajaxData.embarkationPortCode = this.ajaxData.embarkationPortCode ? this.ajaxData.embarkationPortCode : '';

    this.ajaxData.travellingCompanionFirstName = $('#sailingInfoForm #travelPartnerFname').val() ? $('#sailingInfoForm #travelPartnerFname').val() : this.ajaxData.travellingCompanionFirstName;

    this.ajaxData.travellingCompanionLastName = $('#sailingInfoForm #travelPartnerLname').val() ? $('#sailingInfoForm #travelPartnerLname').val() : this.ajaxData.travellingCompanionLastName;

    let ajaxUrl = '';
    let ajaxType = '';
    if (window.location.hostname === 'localhost' && window.location.port === '6565') {
      ajaxUrl = 'json-data/booking-buddy-1.json';
      ajaxType = 'GET';
    } else {
      ajaxUrl = '/shop/gifting/booking-lookup';
      ajaxType = 'POST';
    }
    gfunctions.showLoader();
    $.ajax({
      type: ajaxType,
      url: ajaxUrl,
      data: JSON.stringify(this.ajaxData),
      contentType: 'application/json',
      headers: {
        CSRFToken: token
      }
    }).done((response) => {
      gfunctions.hideLoader();
      if (response.activeSailingId) {
        gfunctions.setCarnivalGiftingBookingCookie(response.vifp, this.ajaxData);
        gfunctions.setSailingContextCookie(response.activeSailingId);
      }
      this.checkNextModal(response);
      gfunctions.hideLoader();
    }).fail(() => {
      gfunctions.hideLoader();
    });
  },

  browseAjaxCall() {
    const token = $('#csrfSessionToken').data('csrf');
    gfunctions.showLoader();
    $.ajax({
      type: 'GET',
      url: '/shop/gifting/browse-mode',
      headers: {
        CSRFToken: token
      }
    }).done((response) => {
      deloitteCookies.remove(`carnivalGiftingBookingCookie-${response.vifp}`);
      if (!this.loggedInUser || (this.loggedInUser && !this.hasSailings)) {
        gfunctions.hideModal('bookingBuddyModal');
      } else {
        window.location.href = '/shop';
      }
      gfunctions.hideLoader();
    }).fail(() => {
      gfunctions.hideLoader();
      // do nothing on error
    });
  },

  checkNextModal(response) {
    if (response.errors && response.errors.errors.length) {
      let errorhtml = '';
      $.each(response.errors.errors, (k, v) => {
        errorhtml += `
        <img src="/_ui/responsive/ccl/assets/icons/16x16px/info_16x16px.svg" alt="error info icon">
        <p>${v.message}</p><br/>`;
      });

      $('body').find('#bbModalError').empty().html(errorhtml);
      $('body').find('#bbModalError').show();
      $('body').find('.btn-submit').prop('disabled', true);
      $('body').find('#checkoutBBflow').prop('disabled', true);
    } else {
      if (response.productAvailable) {
        if (response.redirectUrl) {
          // redirect to the url
          window.location.href = response.redirectUrl;
        } else {
          this.createAddToCart(response);
        }
        // checkFlag is for if user didn't select the product
      } else if ((Number(response.statusCode) === 3) && !response.productAvailable && (!response.checkFlag || this.isPDP)) {
        gfunctions.hideModal('bookingBuddyModal');
        this.openProductUnAvailableModal();
      }

      if (response.closeModal && this.checkout) {
        gfunctions.hideModal('bookingBuddyModal');
        window.location.reload();
      }

      if (response.closeModal && !this.checkout) {
        gfunctions.hideModal('bookingBuddyModal');
        window.location.href = '/shop';
      }
      $('.c-booking-buddy-modal #bbModalError').hide();
      if ((Number(response.statusCode) !== 2 || Number(response.statusCode) !== 3) && response.message) {
        if (Number(response.statusCode) === 4) {
          $('body').find('#bbModalError p').empty().html(response.message);
          $('body').find('#bbModalError').show();
          $('.c-booking-buddy-modal .recipient-f-name').addClass('outline').focus();
        }
        // if there is an error then empty previous data from ajax object
        // temp fix
        //  Object.assign(this.ajaxData, this.emptyObj); // assign empty obj
      }

      // second Modal
      if ((Number(response.statusCode) === 1 || Number(response.statusCode) === 2) && response.shipInfo && !response.portInfo) {
        gfunctions.getBookingBuddyModalHtml(2, (res) => {
          const compiledHtml = gfunctions.createDynamicHTML(res, response);
          $('#bbModalDynamicHtmlDiv').html(compiledHtml);
          if (this.checkout) {
            gfunctions.showModal('bookingBuddyModal');
          }
        });
      }

      // thirdModal Modal
      if ((Number(response.statusCode) === 1 || Number(response.statusCode) === 2) && response.portInfo && response.ageInfo) {
        gfunctions.getBookingBuddyModalHtml(3, (res) => {
          const compiledHtml = gfunctions.createDynamicHTML(res, response);
          $('#bbModalDynamicHtmlDiv').html(compiledHtml);
          if (this.checkout) {
            gfunctions.showModal('bookingBuddyModal');
          }
        });
      }
    }
  },

  openProductUnAvailableModal() {
    gfunctions.showLoader();
    $.ajax({
      type: 'GET',
      url: '/_ui/responsive/ccl/assets/templates/product-unavailable/product-unavailable.html'
    }).done((res) => {
      const compiledHtml = gfunctions.createDynamicHTML(res, 'response');
      $('#dynamicProductUnavailableModal').html(compiledHtml);
      gfunctions.showModal('productUnavailableModal');
      gfunctions.hideLoader();
    }).fail(() => {
      gfunctions.hideLoader();
    });
  },

  createAddToCart(response) {
    const token = $('#csrfSessionToken').data('csrf');
    if (response.redirectUrl) {
      // redirect to the url
      window.location.href = response.redirectUrl;
    } else if (response.productAvailable) {
      gfunctions.hideModal('bookingBuddyModal');

      $('#addToCartSuccessModal').addClass('bbFlow');
      if (response.productType === 'FTF' || response.productType === 'CHEERS' || response.productType === 'INTERNET' || response.productType === 'BUBBLES' || response.productType === 'TR') {
        const dataObj = {};
        dataObj.productCode = response.productType === 'FTF' ? response.variantId : response.productCode;
        if (this.isPDP) {
          gfunctions.hideModal('bookingBuddyModal');
          window.location.reload();
        } else {
          $('#clpAddToCartModal').addClass('bbFlow');
          $('#termsAndConditionsModal').addClass('bbFlow');
          // open generic addToCart/coflict clp modal
          CCL.clpAddToCart.loadJsonData(dataObj);
        }
      } else if (response.productType === 'SF' || response.productType === 'SFAP' || response.productType === 'SFP') {
        if (this.isPDP) {
          gfunctions.hideModal('bookingBuddyModal');
          window.location.reload();
        } else {
          $('#alcoholAtcModal').addClass('bbFlow');
          $('#termsAndConditionsModal').addClass('bbFlow');
          // open alcohol atc modal
          CCL.atcAlcohol.loadAlcoholJsonData(response.productCode);
        }
      } else if (response.productType === 'DI') {
        if (this.isPDP) {
          gfunctions.hideModal('bookingBuddyModal');
          window.location.reload();
        } else {
          $('#diningAtcModal').addClass('bbFlow');
          // open dining atc modal
          CCL.atcDining.loadDiningJsonData(response.productCode);
        }
      } else if (response.productType === 'XD') {
        if (this.isPDP) {
          gfunctions.hideModal('bookingBuddyModal');
          window.location.reload();
        } else {
          $('#diningAtcModal').addClass('bbFlow');
          // open dining atc modal
          CCL.atcxDining.loadDiningJsonData(response.productCode);
        }
      } else {
        const data = {
          CSRFToken: token,
          productCodePost: response.variantId
        };
        // open shoreEx conflict modal
        CCL.conflictModal.loadModalData(data);
      }
    } else {
      gfunctions.hideModal('bookingBuddyModal');
      this.openProductUnAvailableModal();
    }
  },

  bbLbAddToCartAjax(activeSailingId) {
    const token = $('#csrfSessionToken').data('csrf');
    const dataObj = {
      productCode: this.currentProductCode
    };
    if (activeSailingId) {
      dataObj.sailingId = activeSailingId;
    }
    gfunctions.showLoader();
    $.ajax({
      type: 'POST',
      url: '/shop/gifting/sailing/check-product',
      contentType: 'application/json',
      headers: {
        CSRFToken: token
      },
      data: JSON.stringify(dataObj)
    }).done((response) => {
      this.createAddToCart(response);
      gfunctions.hideLoader();
    }).fail(() => {
      gfunctions.hideLoader();
    });
  },

  bbSailingCheckoutAjax() {
    gfunctions.showLoader();
    $.ajax({
      type: 'GET',
      url: '/shop/gifting/checkout/add-sailing',
      contentType: 'application/json'
    }).done((response) => {
      window.location.reload();
      gfunctions.hideLoader();
    }).fail(() => {
      gfunctions.hideLoader();
    });
  },

  valiateInputs() {
    let isValid = true;
    const p = /[^a-zA-Z\-']/;
    $('#giftLinkForm input[required]').each((i, v) => {
      const t = $(v).val();
      // restrict special char in fname and lname
      if (p.test(t)) {
        $(v).addClass('invalid-input');
        $('#bbModalError p').html('Numbers or special characters are not allowed');
        $('#bbModalError').show();
        $('#saveButtonOne').prop('disabled', true);
        $('body').find('#checkoutBBflow').prop('disabled', true);

        isValid = false;
      }

      if ($(v).val().length > 24) {
        $('#bbModalError p').html('First name & last name should be less than 24 characters');
        $('#bbModalError').show();
        isValid = false;
      }

      if ($(v).val() === '') {
        isValid = false;
      }
    });
    if (isValid && (($('#giftLinkForm .booking-number').val() && $('#giftLinkForm .booking-number').val().match(/^[a-zA-Z0-9]{6,6}$/)) || this.selectedMonth)) {
      $('#saveButtonOne').prop('disabled', false);
      $('body').find('#checkoutBBflow').prop('disabled', false);
    } else {
      $('#saveButtonOne').prop('disabled', true);
      $('body').find('#checkoutBBflow').prop('disabled', true);
    }
  },

  validateThirdModal() {
    const dob = $('.multiple-sailing-extended-modal-dialog #dob').val();
    const isDobValid = gfunctions.validateDob(dob);
    if (dob && !isDobValid) {
      $('.multiple-sailing-extended-modal-dialog #dob').addClass('invalid-input');
    } else {
      $('.multiple-sailing-extended-modal-dialog #dob').removeClass('invalid-input');
    }
    if (this.ajaxData.ageCode || dob) {
      $('#saveButtonThree').prop('disabled', false);
    } else {
      $('#saveButtonThree').prop('disabled', true);
    }

    if (dob && !isDobValid) {
      $('#saveButtonThree').prop('disabled', true);
    }
  },

  cruiseCloseAjax() {
    gfunctions.showLoader();
    $.ajax({
      type: 'GET',
      url: '/shop/gifting/remove-booking'
    }).done((res) => {
      deloitteCookies.remove(`carnivalGiftingBookingCookie-${res.vifp}`);
      if (res.activeSailingId) {
        gfunctions.setSailingContextCookie(res.activeSailingId);
        window.location.reload();
      } else if (res.activeSailingId === '') {
        window.location.reload();
      }
      gfunctions.hideLoader();
    }).fail(() => {
      gfunctions.hideLoader();
    });
  },

  radioSelect() {
    $(document.body).on('click keypress', '.browse-all-products-label, .browse-all-products-input', (event) => {
      if (event.type === 'click' || event.keyCode === 13) {
        $('.custom-control-label').removeClass('selected');
        $(event.currentTarget).addClass('selected');
        $('.logged-out-user-form').removeClass('show');
        $('.booked-cruiser-form').removeClass('show');
        this.activeSailingId = 0;
        this.giftGiver = null;
        if (!this.bookingAdded) {
          $('.browse-all-error').fadeIn('slow');
        }
        $('#saveButtonOne').prop('disabled', false);
        $('#checkoutBBflow').prop('disabled', false);
      }
    });

    $(document.body).on('click keypress', '.booking-place-date, .booking-place-date-input', (event) => {
      if (event.type === 'click' || event.keyCode === 13) {
        $('.browse-all-error').hide();
        $('.custom-control-label').removeClass('selected');
        $(event.currentTarget).addClass('selected');
        $('.logged-out-user-form').removeClass('show');
        $('.booked-cruiser-form').removeClass('show');
        const tempArr = event.currentTarget.id.split('-');
        this.activeSailingId = tempArr[tempArr.length - 1];
        this.giftGiver = event.currentTarget.dataset.giftgiver;
        $('#saveButtonOne').prop('disabled', false);
        $('#checkoutBBflow').prop('disabled', false);
      }
    });
    // $(document.body).on('keypress','.booking-number',(event)=>{

    // });
    $(document.body).on('click keypress', '#giftLinkFormCheckBox', (event) => {
      if (event.type === 'click' || event.keyCode === 13) {
        $(event.currentTarget.nextSibling.nextElementSibling).attr('aria-label', 'Expanded I want to give a gift to booked cruiser that has info to complete inside');
        $('.browse-all-error').hide();
        this.activeSailingId = 1;
        $('.custom-control-label').removeClass('selected');
        $(event.currentTarget).addClass('selected');
        $('.logged-out-user-form').removeClass('show');
        $('.booked-cruiser-form').addClass('show');
        $('.link-error-text').hide();
        this.giftGiver = null;
        //  $('#saveButtonOne').prop('disabled', true);
      }
    });
    $(document.body).on('click keypress', '.booked-cruiser-label', (event) => {
      if (event.type === 'click' || event.keyCode === 13) {
        $('.browse-all-error').hide();
        this.activeSailingId = 1;
        $('.custom-control-label').removeClass('selected');
        $(event.currentTarget).addClass('selected');
        $('.logged-out-user-form').removeClass('show');
        $('.booked-cruiser-form').addClass('show');
        $('.link-error-text').hide();
        this.giftGiver = null;
      }
    });

    $(document.body).on('click keypress', '#linkBookinFormCheckbox', (event) => {
      if (event.type === 'click' || event.keyCode === 13) {
        $(event.currentTarget.nextSibling.nextElementSibling).attr('aria-label', 'Expanded Link a booking to my profile that has info to complete inside');
        $('.browse-all-error').hide();
        this.activeSailingId = 2;
        $('.custom-control-label').removeClass('selected');
        $(event.currentTarget).addClass('selected');
        $('.booked-cruiser-form').removeClass('show');
        $('.logged-out-user-form').addClass('show');
        this.giftGiver = null;
      }
    });
  },


  allClickEvents() {
    this.valiateInputs();
    $('.booking-info .custom-control-label, .browse-all-products .custom-control-label, .logged-out-user .custom-control-label').click((e) => {
      $('#saveButtonOne').prop('disabled', false);
    });

    $(document.body).on('click keypress', '#giftLinkFormCheckBox, .booked-cruiser .custom-control-label', (event) => {
      $('#saveButtonOne').prop('disabled', true);
    });

    $('.c-recipient-info-form .info-null').click(() => {
      $('.c-recipient-info-form .info-description').slideToggle();
    });

    // When click on dropdown items
    $('.month-item').click((e) => {
      $('#sailingMonths')[0].innerText = e.currentTarget.innerText;
      $('.month-item').removeClass('active');
      e.currentTarget.className += ' active';
      this.selectedMonth = e.currentTarget.dataset.month;
      this.valiateInputs();
      $(e.currentTarget.closest('.dropdown-menu').previousElementSibling).focus();
    });

    // When click on ship dropdown items
    $(document.body).on('click', '.ship-item', (e) => {
      $('#shipDropdownMenu')[0].innerText = e.currentTarget.innerText;
      $('.ship-item').removeClass('active');
      e.currentTarget.className += ' active';
      this.ajaxData.shipCode = e.currentTarget.id;
      $('#saveButtonTwo').prop('disabled', false);
    });

    // When click on ship dropdown items
    $(document.body).on('click', '.age-item', (e) => {
      $('#ageDropdownMenu')[0].innerText = e.currentTarget.innerText;
      $('.age-item').removeClass('active');
      e.currentTarget.className += ' active';
      this.ajaxData.ageCode = e.currentTarget.id;
      $('#saveButtonThree').prop('disabled', false);
    });

    // When click on age dropdown items
    $(document.body).on('click', '.sailingPort-item', (e) => {
      $('#sailingPortMenu')[0].innerText = e.currentTarget.innerText;
      $('.sailingPort-item').removeClass('active');
      e.currentTarget.className += ' active';
      this.ajaxData.embarkationPortCode = e.currentTarget.id;
      $('#saveButtonThree').prop('disabled', false);
    });

    // When user types in input
    $('#giftLinkForm input[type=text]').keyup((e) => {
      const patt = /^\S*$/;
      $('#bbModalError').hide();
      $('#saveButtonOne').prop('disabled', false);
      $('#checkoutBBflow').prop('disabled', false);
      if ($(e.currentTarget)[0].hasAttribute('required') && !e.currentTarget.value) {
        $(e.currentTarget).addClass('invalid-input');
      } else {
        $(e.currentTarget).removeClass('invalid-input');
        if (!patt.test(e.currentTarget.value)) {
          $(e.currentTarget).addClass('invalid-input');
          $('#bbModalError p').html('Whitespace not allowed');
          $('#bbModalError').show();
          $('#saveButtonOne').prop('disabled', true);
          $('#checkoutBBflow').prop('disabled', true);
          return;
        }

        if ($(e.currentTarget).hasClass('booking-number') && e.currentTarget.value.length) {
          const bookingNumRegex = /^[a-zA-Z0-9]{6}$/;
          if (!bookingNumRegex.test(e.currentTarget.value)) {
            $('#bbModalError p').html('Invalid booking number');
            $('#bbModalError').show();
            $('#saveButtonOne').prop('disabled', true);
            $('#checkoutBBflow').prop('disabled', true);

            return;
          }
        }
      }
      this.valiateInputs();
    });

    $(document.body).on('#shipInfoForm input[type=text]').keyup((e) => {
      const email = $('.multiple-sailing-modal-dialog #emailAddress').val();
      const phone = $('.multiple-sailing-modal-dialog #phoneNumber').val();
      const isEmailValid = gfunctions.validateEmail(email);
      if (email && !isEmailValid) {
        $('.multiple-sailing-modal-dialog #emailAddress').addClass('invalid-input');
      } else {
        $('.multiple-sailing-modal-dialog #emailAddress').removeClass('invalid-input');
      }
      if (email || phone || this.ajaxData.shipCode) {
        $('#saveButtonTwo').prop('disabled', false);
      } else {
        $('#saveButtonTwo').prop('disabled', true);
      }
      if (email && !isEmailValid) {
        $('#saveButtonTwo').prop('disabled', true);
      }
    });


    $(document.body).on('#sailingInfoForm input[type=text]').keyup((e) => {
      this.validateThirdModal();
    });

    // When click on checkout page save and continue
    $('#checkoutBBflow').click((e) => {
      this.ajaxData.step = 'first';
      this.fetchBooking();
    });

    // When click on 1st modal save
    $('#saveButtonOne').click((e) => {
      this.ajaxData.step = 'first';
      this.fetchBooking();
    });

    // When user click on 2nd modal save
    $(document.body).on('click', '#saveButtonTwo', (e) => {
      this.ajaxData.step = 'second';
      this.save();
    });

    // When user click on 3rd modal save
    $(document.body).on('click', '#saveButtonThree', (e) => {
      this.ajaxData.step = 'third';
      this.save();
    });

    // When user click on product not availble close click
    $(document.body).on('click', '#productUnavailableModalClose', (e) => {
      gfunctions.hideModal('productUnavailableModal');
      if (this.isPDP) {
        window.location.href = '/shop';
      } else {
        window.location.reload();
      }
    });

    // When user click on product not availble Keep Shopping btn
    $(document.body).on('click', '.keep-shopping-btn', (e) => {
      gfunctions.hideModal('productUnavailableModal');
      if (this.isPDP) {
        window.location.href = '/shop';
      } else {
        window.location.reload();
      }
    });

    // When user click on booking buddy close
    $(document.body).on('click', '#bookingBuddyModal .close', (e) => {
      $.each(this.ajaxData, (k, v) => {
        this.ajaxData[k] = '';
      });
    });

    // When user click on added to cart success close
    $(document.body).on('click', '#addToCartSuccessModal.bbFlow .close', (e) => {
      window.location.reload();
    });

    // When user click on clp Add to Cart close
    $(document.body).on('click', '#clpAddToCartModal.bbFlow .close', (e) => {
      window.location.reload();
    });

    // When user click on alcohol Add to Cart close
    $(document.body).on('click', '#alcoholAtcModal.bbFlow .close', (e) => {
      window.location.reload();
    });

    // When user click on added to cart success close
    $(document.body).on('click', '#termsAndConditionsModal.bbFlow .close', (e) => {
      window.location.reload();
    });

    $(document.body).on('click', '#termsAndConditionsModal.bbFlow .btn-cancel', (e) => {
      window.location.reload();
    });

    if ($(document.body).find('.goto-cruise-manager .rightSidebar').css('display') === 'block') {
      $('.goto-cruise-manager a').on('keydown', (event) => {
        if ((event.keyCode === 9) && !(event.shiftKey)) {
          $(() => {
            $('.close').focus();
          });
        }
        if ((event.keyCode === 9) && (event.shiftKey)) {
          $(() => {
            $('.custom_tooltip').focus();
          });
        }
      });
      $('.close').on('keydown', (event) => {
        if ((event.keyCode === 9) && (event.shiftKey)) {
          $(() => {
            $('.goto-cruise-manager a').focus();
          });
        }
      });
    } else if ($(document.body).find('.goto-cruise-manager .rightSidebar').length === 0) {
      $('.custom_tooltip').on('keydown', (event) => {
        if ((event.keyCode === 9) && !(event.shiftKey)) {
          $(() => {
            $('.close').focus();
          });
        }
      });
      $('.close').on('keydown', (event) => {
        if ((event.keyCode === 9) && (event.shiftKey)) {
          $(() => {
            $('.custom_tooltip').focus();
          });
        }
      });
    }
  },

  modalEvents() {
    const modalEl = $('#bookingBuddyModal');
    const firstFocusable = gfunctions.getFocusableElements(modalEl);
    const lastFocusable = gfunctions.getFocusableElements(modalEl, 'last');
    const cruiseAnchor = $('#cruiseManagerLink');

    firstFocusable.on('keydown', (event) => {
      if ((event.keyCode === 9) && (event.shiftKey)) {
        event.preventDefault();
        if ((cruiseAnchor.attr('id') === lastFocusable.attr('id')) && ($('.rightSidebar:visible').length === 0)) {
          $('a.organizer-access-modal-open-button').focus();
        } else {
          lastFocusable.focus();
        }
      }
    });
    lastFocusable.on('keydown', (event) => {
      if ((event.keyCode === 9) && !(event.shiftKey)) {
        event.preventDefault();
        firstFocusable.focus();
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/components/c-booking-buddy/booking-buddy.js